import { sortByClientDevelopmentCategory } from 'utils';
import { getRTCUpdatedDataClone, sortRTCDataCollection } from 'modules/clients/reducers/utils';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  data: [],
  categories: [],
  loading: false,
  error: null,
};

const reasonToContact = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.REASON_TO_CONTACT_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.REASON_TO_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload.isSortedByCompleted ? sortRTCDataCollection(payload.data) : payload.data,
        categories: sortByClientDevelopmentCategory(payload.categories),
      };
    case actionTypes.REASON_TO_CONTACT_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.REASON_TO_CONTACT_SET_COMPLETED_SUCCESS:
      return {
        ...state,
        data: getRTCUpdatedDataClone(state.data, payload.data, payload.isSortedByCompleted),
      };
    case actionTypes.REASON_TO_CONTACT_SINGLE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [payload],
        categories: [],
      };
    case actionTypes.SET_CLIENT_CONNECTS: {
      return {
        ...state,
        data: getRTCUpdatedDataClone(state.data, payload, true),
      };
    }
    case actionTypes.REASON_TO_CONTACT_RESTORE:
      return {
        ...state,
        data: payload,
      };
    default:
      return state;
  }
};

export default reasonToContact;
